// Site/EditSite.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import siteService from "../../services/siteService";
import SiteForm from "./SiteForm/SiteForm";

const EditSite = () => {
  const { siteID } = useParams();
  const navigate = useNavigate();

  const [initialValues, setInitialValues] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSiteDetails = async () => {
      try {
        const data = await siteService.getSiteDetails(siteID);

        setInitialValues({
          site_code: data.site_code || "",
          institution: data.institution || "",
          country: data.country || "United States",
          contact_person: data.contact || "",
          email: data.contact_email || "",
          timezone: data.timezone || "America/New_York",
        });
      } catch (err) {
        console.error("Failed to load site:", err);
        toast.error("Failed to load site details.");
      } finally {
        setLoading(false);
      }
    };

    fetchSiteDetails();
  }, [siteID]);

  const handleUpdate = async (formData) => {
    const payload = {
      site_name: `Site ${String(formData.site_code).padStart(4, "0")} - ${formData.institution}`,
      site_code: formData.site_code,
      institution: formData.institution,
      country: formData.country,
      contact: formData.contact_person,
      contact_email: formData.email,
      timezone: formData.timezone,
    };

    try {
      await siteService.updateSite(siteID, payload);
      toast.success("Site updated successfully");
      navigate(-1);
    } catch (err) {
      console.error("Failed to update site:", err);
      toast.error("Error updating site.");
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-gray-500">
        Loading...
      </div>
    );
  }

  if (!initialValues) {
    return (
      <div className="min-h-screen flex items-center justify-center text-red-600">
        Failed to load site.
      </div>
    );
  }

  return (
    <SiteForm
      onSubmit={handleUpdate}
      initialValues={initialValues}
      isLoading={false}
      title="Edit Site"
      mode="edit" // passed to show "Save Changes"
    />
  );
};

export default EditSite;
